import { Component, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { ToastrService } from 'ngx-toastr';
import Stepper from 'bs-stepper';
import { Router } from '@angular/router';
import { FileUploadOptions } from 'app/services/common/fileupload/fileupload.component';
import { ControllerType } from 'app/services/http-client.service';
import { CurrencyService } from 'app/services/models/currency.service';
import * as XLSX from 'xlsx';
import { CreateCompanies } from 'app/dtos/company/create-companies';

@Component({
  selector: 'app-company-create',
  templateUrl: './company-create.component.html',
  styleUrls: ['./company-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyCreateComponent implements OnInit {

  public contentHeader: object;
  public companyForm: FormGroup;
  public labelControl: FormControl;
  public labels: string[] = [];
  public itemControllerTypes = [];
  public selectedFiles: File[] = [];
  fileName: string = 'Dosya Seç';

  public currencies: any[] = [];
  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private currencyService: CurrencyService,
    private companyService: CompanyService,
    private toastService: ToastrService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Şirket',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Şirketler Listesi',
            isLink: true,
            link: '/admin/company'
          },
          {
            name: 'Şirketler Oluşturma',
            isLink: false,
          },
        ]
      }
    }
    this.horizontalWizardStepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    });

    this.companyForm = this.fb.group({
      companyName: [null, [Validators.required, Validators.maxLength(200)]],
      mail: [null],
      phoneNumber: [null],
      phoneNumber2: [null],
      address: [null, Validators.maxLength(200)],
      taxNumber: [null],
      taxAdministration: [null, Validators.maxLength(50)],
      futuresDay: [0],
      discountRate: [0],
      description: [null],
      categoryId: [null],
      currencyId: [null]
    });

    this.labelControl = new FormControl('');

    await this.getAllControllerTypes();
    await this.getAllCurrencies();

  }

  isAdvancedChange: boolean = false;

  toggleAdvancedUpload(event: any) {
    this.isAdvancedChange = event.target.checked;
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = [input.files[0]];
      this.fileName = input.files[0].name;
      console.log(this.selectedFiles);
    }
  }

  async getAllCurrencies() {
    const data = await this.currencyService.getAllPageCurrency(0, 100, '');
    console.log(data);
    this.currencies = data.currenies;
    this.companyForm.patchValue({
      currencyId: this.currencies.find(p => p.currencyName == "TL").id
    })
  }
  async getAllControllerTypes() {
    const data = await this.categoryService.getAllCategory(0, 100, null, 2);
    this.itemControllerTypes = data.categories;
  }
  private horizontalWizardStepper: Stepper;

  horizontalWizardStepperNext(stepId: string) {
    if (this.isStepValid(stepId)) {
      this.horizontalWizardStepper.next();
    }
  }

  horizontalWizardStepperPrevious() {
    this.horizontalWizardStepper.previous();
  }

  isStepValid(stepId: string): boolean {
    const stepForm = this.getStepForm(stepId);
    return stepForm ? stepForm.valid : false;
  }

  getStepForm(stepId: string): FormGroup | null {
    // Burada adım ID'sine göre formu döndüren bir yöntem ekleyin.
    // Bu yöntem adım ID'sine göre uygun form grubunu döndürmelidir.
    return this.companyForm;
  }


  addLabel(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Form gönderimini önle

      const inputElement = event.target as HTMLInputElement;
      const newLabel = inputElement.value.trim(); // Giriş değerini al

      // Eğer yeni etiket geçerliyse ve zaten mevcut etiketler arasında yoksa
      if (newLabel && !this.labels.includes(newLabel)) {
        this.labels.push(newLabel); // Yeni etiketi ekle
        inputElement.value = null; // Giriş alanını temizle
        inputElement.focus(); // Giriş alanına yeniden odaklan
      }

      console.log(this.labels); // Etiketleri konsola yazdır
    }
  }


  removeLabel(label: string) {
    this.labels = this.labels.filter(l => l !== label);
  }



  preventSubmit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  private transformEmptyToNull(obj: any): any {
    const result = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = obj[key] === '' ? null : obj[key];
      }
    }
    return result;
  }

  companies: any[] = [];
  isCompaniesValid: boolean = false;
  allCompaniesValid: boolean = true;

  async onSubmit() {
    console.log(this.labels);
    if (this.companyForm.valid) {
      const transformedValues = this.transformEmptyToNull(this.companyForm.value);
      const companyData = {
        ...transformedValues,
        labels: this.labels.length > 0 ? this.labels : null,
        files: this.selectedFiles
      };
      console.log(companyData);

      const data = await this.companyService.createCompany(companyData);
      console.log("sonuç : ", data);
      if (data.status == true) {
        this.router.navigate(['admin/company'])
        this.toastService.success(data.message);

      } else {
        this.toastService.error(data.message);
      }
    } else {
      this.companyForm.markAllAsTouched();
    }
  }

  getByIdCurrency(currencyName) {
    const currency = this.currencies.find(p => p.currencyName == currencyName);
    return currency;
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });

      // İlk sayfayı al
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Verileri JSON formatına çevir
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Sütun başlıklarını ayarlamak için
      const companies = jsonData.slice(1).map(row => {

        const currency = row[6] ? this.getByIdCurrency(row[6]) : null;
        if (row[6] && !currency) {
          this.toastService.error(`Para birimi "${row[6]}" bulunamadı. Lütfen geçerli bir para birimi girin.`, "Para Bulunamadı!", {
            timeOut: 3000
          });
          this.allCompaniesValid = false;
        }

        return {
          name: row[0], // Ürün adı
          mail: row[1], // Satış fiyatı
          phoneNumber: row[2], // Alış fiyatı
          address: row[3],
          taxAdministration: row[4],
          TaxNumber: row[5],
          currency: currency,
        };
      }).filter(company => {
        // Check if all fields in the product are null or undefined
        return company.name || company.currency;
      });

      const invalidProducts = companies.filter(company =>
        !company.name ||
        company.phoneNumber.length == 10 ||
        company.TaxNumber.length <=11
      );

      this.isCompaniesValid = invalidProducts.length > 0 ? false : true;

      console.log(this.isCompaniesValid);

      if (invalidProducts.length > 0) {
        this.toastService.error('Bazı Firmalar uygun olmayan biçimde.');
      }

      this.companies = companies;

      console.log(companies);
    };

    reader.readAsBinaryString(file);
  }

  resetFileInput(fileInput: HTMLInputElement) {
    // Dosya girişi temizle
    fileInput.value = '';
    this.companies = [];
    this.isCompaniesValid = false;
    this.allCompaniesValid = true;
  }

  async saveCompanies() {
    if (!this.isCompaniesValid) {
      this.toastService.error('Lütfen geçerli Firma bilgileri yükleyin.');
      return;
    } else {
      this.companies = this.companies.map(company => {
        const createCompany: CreateCompanies = {
          companyName: company.name, // Trim whitespace
          currencyId: company.currency?.id, // Use optional chaining
          address: company.address ?? null,
          mail: company.mail ?? null,
          phoneNumber: company.phoneNumber?.toString() ?? null, // Assumes this field is required
          taxAdministration: company.taxAdministration ?? null, // Assumes this field is required
          taxNumber: company.taxNumber?.toString() ?? null // Use optional chaining
        };
        return createCompany;
      });
      const response = await this.companyService.createCompanies(this.companies);
      if (response.status) {
        this.toastService.success(response.message);
        this.router.navigate(['/admin/company']);
      } else {
        this.toastService.error(response.message);
      }
    }
    console.log(this.companies);
  }
}